<template>
   <div>
      <table>
         <tr class="pt-3">
            <td>
               <input v-show="hideInputFile" type="file" ref="fileInput" @change="handleFileChange" accept="image/*,.pdf">
               <div v-if="typeImage === 'gallery'" class="align-center justify-center py-7 box-upload-image" style="width: 87.5px !important; height: 87.5px !important;">
                  <v-icon
                    size="40"
                    color="#2E263D"
                    @click="addImage()"
                  >
                    mdi-plus
                  </v-icon>
               </div>
               <div v-else class="align-center justify-center py-7 box-upload-image" style="width: 150px !important; height: 50.5px !important;">
                  <v-icon
                    size="40"
                    color="#2E263D"
                    @click="addImage()"
                  >
                    mdi-image-edit-outline
                  </v-icon>
               </div>
            </td>
         </tr>
      </table>
      <v-dialog
        v-model="dialogImage"
        v-if="imageView"
        max-width="800"
      >
        <v-card>
          <v-card-title class="px-0 pt-0 mb-3">
            <v-sheet
              color="white"
              elevation="3" width="100%" class="px-8 py-3">
              <v-row>
                <v-col class="text-left">Preview</v-col>
                <v-col class="text-right">
                  <v-icon @click="dialogImage=false">mdi-close</v-icon>
                </v-col>
              </v-row>
            </v-sheet>
          </v-card-title>
          <v-card-text class="pb-0 mb-0 text-center">
            <v-img :src="imageView.url" max-width="500" class="mx-auto pb-2"></v-img>
            {{ imageView.updatedUserId }} - {{ imageView.createdAt }}
          </v-card-text>

          <v-card-actions class="pa-0 mt-6">
            <v-sheet
              color="white"
              elevation="3" width="100%" class="px-4 py-3">
              <v-row>
                <v-col cols="6" class="text-left">
                  <v-btn
                    color="grey ligthen-3"
                    dark
                    @click="dialogImage = false"
                  >
                    ยกเลิก
                  </v-btn>
                </v-col>
                <v-col cols="6" class="text-right">
                  <v-btn
                    color="red ligthen-2"
                    dark
                    @click="startDelete(imageView.id, imageView.url)"
                  >
                    ลบ
                  </v-btn>
                </v-col>
              </v-row>
            </v-sheet>
          </v-card-actions>
        </v-card>
      </v-dialog>
   </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'

export default {
  name: 'ComponentFileUpload',
  props: {
    actionId: {
      type: Number
    },
    typeImage: {
      type: String
    },
    onUploadSuccess: {
      type: Function,
      required: false
    }
  },
  components: { },
  computed: {},
  data () {
    return {
      shopId: 'Uae2627b600f96dee6bb85c7fc860db26',
      model: null,
      hideInputFile: false,
      pictureUrl: [],
      loading: false,
      fileUpload1: [],
      dialogImage: false,
      imageView: null,
      updatedUserId: this.$session.getAll().data.userName
    }
  },
  async mounted () {
  },
  methods: {
    openImage (id, url, createdAt, updatedUserId) {
      createdAt = moment(createdAt).format('YYYY-MM-DD HH:mm')
      this.imageView = { id, url, createdAt, updatedUserId }
      this.dialogImage = true
    },
    handleFileChange (event) {
      const selectedFile = event.target.files[0]
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png']
      const fileSize = selectedFile.size
      if (allowedTypes.includes(selectedFile.type)) {
        if (fileSize > 10 * 1024 * 1024) {
          this.$swal(this.languageSelect === 0 ? 'ไฟล์มีขนาดใหญ่เกินไป' : 'The file is too large.', this.languageSelect === 0 ? 'กรุณาอัพโหลดไฟล์ที่มีขนาดไม่เกิน 10 MB' : 'Please upload a file less than 10 MB.', 'error')
        } else {
          this.fileUpload1 = event.target.files[0]
          this.uploadfile()
        }
      } else {
        this.$swal('ประเภทไฟล์ไม่ถูกต้อง', 'รองรับไฟล์ประเภท (jpg, png) เท่านั้น', 'error')
        // this.fileUpload1.push(event.target.files[0])
        // this.uploadfile()
      }
    },
    addImage () {
      this.textImage = 'fileUpload1'
      this.$refs.fileInput.click()
    },
    async uploadfile () {
      const _this = this
      _this.pictureUrl.splice(0, 0, { id: '-1', url: 'https://media1.giphy.com/media/3oEjI6SIIHBdRxXI40/200w.gif?cid=6c09b952y7ztapa8z7kaxwhadhgq3jo5cnwyweldkrq62ybx&ep=v1_gifs_search&rid=200w.gif&ct=g' })
      let checkUpload1 = this.fileUpload1 || ''
      if (checkUpload1) {
        let params = new FormData()
        params.append('files', this.fileUpload1)
        params['createdUserId'] = this.updatedUserId
        params['updatedUserId'] = this.updatedUserId
        await axios
          .post(this.$DNS_IP + `/file/upload/updateFile`, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(async (response) => {
            let pictureUrl = response.data
            if (this.onUploadSuccess && typeof this.onUploadSuccess === 'function') {
              this.onUploadSuccess(pictureUrl)
            }
            // pictureUrl = pictureUrl.length > 0 ? pictureUrl : ''
            // await _this.saveFile(pictureUrl[pictureUrl.length - 1])
          })
      }
    }
  }
}
</script>
<style lang="css">
.v-slide-group__wrapper {
   overflow: hidden !important;
}
.box-upload-image {
  display: flex;align-items: left;flex-direction: column;
  border-radius: 5px;
  background-color: #EFEEF0;
  border-color: #C1BEC5;
}
</style>



// WEBPACK FOOTER //
// src/components/File/uploadFile.vue